"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
exports.stringify = stringify;
var _diagnostics = _interopRequireDefault(require("./diagnostics"));
const log = (0, _diagnostics.default)('json');

/**
 * Safely run JSON method.
 *
 * @param {String} name Function name.
 * @param {...[Mixed]} args Valid arguments
 * @returns {Mixed|undefined} Parsed or stringified object.
 * @api private
 */
function run(name) {
  try {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return JSON[name](...args);
  } catch (error) {
    log(error.message);
  }
}

/**
 * Proxy to JSON.stringify.
 *
 * @returns {String|undefined} stringified representation of the provided arguments.
 * @api public
 */
function stringify() {
  return run('stringify', ...arguments);
}

/**
 * Proxy to JSON.parse.
 *
 * @returns {Object|undefined} parsed object or undefined.
 * @api public
 */
function parse() {
  return run('parse', ...arguments);
}

//
// Export both functions.
//